module.exports = __webpack_public_path__ + "img/no3.a3264618.jpg";